export default __webpack_public_path__ + "static/media/poster15.7ff9c66f.png";